import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cliq_token";

export function setStoredToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getStoredToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer token automatically — mobile-Safari-proof fallback for httpOnly cookies
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e, fallback = "Request failed") {
  // 1) Server returned a structured error → prefer detail
  const detail = formatApiErrorDetail(e?.response?.data?.detail);
  if (detail) return detail;

  // 2) HTTP response without detail → use status
  if (e?.response?.status) {
    return `Request failed (${e.response.status}). Please try again.`;
  }

  // 3) Network-level failure (CORS, offline, DNS, timeout) — never silently say "something went wrong"
  if (e?.code === "ERR_NETWORK" || e?.message === "Network Error") {
    return "Can't reach the server. Check your connection and try again.";
  }
  if (e?.message) return e.message;
  return fallback;
}
